import MainComponent from './Main.component';

export * from './Main.component';
export default MainComponent;
